export enum InvoicingStatusEnum {
  DRAFT= 'DRAFT',
  STAND_BY= 'STAND_BY',
  TRANSMITTED= 'TRANSMITTED',
  GENERATED= 'GENERATED',
  TO_BE_PAID= 'TO_BE_PAID',
  VALIDATED= 'VALIDATED',
  REFUSED= 'REFUSED'
}
